import { createUseStyles, withTheme } from '@glu/theming';
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import RangeSelect from './RangeSelect';
import DateSelect from './DateSelect';
import styles, { DATEPICKER_OVERLAP } from './RangeLayout.styles';

const useStyles = createUseStyles(styles);

const RangeLayout = (props) => {
  const {
    RangeSelectProps, alignRight, editing, onTop, setEditing
  } = props;
  const classes = useStyles();
  const dateSelectStyle = RangeSelectProps.width
    ? { right: RangeSelectProps.width - DATEPICKER_OVERLAP }
    : undefined;
  return (
    <div data-qa="ranges-layout" className={classes.root}>
      <div
        data-qa="range-select"
        className={classnames(classes.rangeSelect, {
          [classes.onTop]: onTop,
          [classes.alignRight]: alignRight
        })}
        style={RangeSelectProps.width ? { width: RangeSelectProps.width } : undefined}
      >
        <RangeSelect setEditing={setEditing} {...props} />
      </div>
      {editing && (
      <div
        data-qa="date-select"
        className={classnames(classes.dateSelect, { [classes.alignRight]: alignRight })}
        style={dateSelectStyle}
      >
        <DateSelect {...props} />
      </div>
      )}
    </div>
  );
};

RangeLayout.propTypes = {
  RangeSelectProps: PropTypes.shape({ width: PropTypes.number }).isRequired,
  alignRight: PropTypes.bool.isRequired,
  editing: PropTypes.bool.isRequired,
  onTop: PropTypes.bool.isRequired,
  setEditing: PropTypes.func.isRequired
};

export default withTheme(RangeLayout);
